/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcHeartRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M10.956 5.768c-1.56-2.164-4.522-2.493-6.478-.747C2.481 6.804 2.36 10 4.225 11.943L12 20.039l7.774-8.096c1.866-1.942 1.745-5.14-.253-6.922-1.956-1.746-4.919-1.417-6.477.747l-.314.435a.9.9 0 0 1-1.46 0zM12 4.195C9.74 1.65 5.878 1.36 3.28 3.678.517 6.144.359 10.516 2.927 13.19l7.869 8.194c.66.688 1.747.688 2.407 0l7.87-8.194c2.567-2.674 2.41-7.046-.353-9.512-2.599-2.32-6.46-2.028-8.72.517"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcHeartRegular;
